import * as Sentry from '@sentry/vue'

const UNLEASH_START_MUTATION = 'featureToggles/startUnleash'

// Init After Unleash Start
export const loaderCreator = (loader, mutationType = UNLEASH_START_MUTATION) => (store) => {
  store.subscribe((mutation) => {
    if (mutation.type !== mutationType) return
    try {
      loader(store)
    } catch (error) {
      Sentry.captureException(new Error('Init 3rd party inside vuex plugin'), {
        extra: {
          error,
        },
      })
    }
  })
}
